import colorsCursor from '@/assets/data/colors.json';
import store from '@/store';

export default class DragImage {
  constructor() {
    this.images = [];

    this.isHolding = false;

    this.currentImage = null;
    this.slices = {
      width: 0,
      numberOf: 0,
      sectors: [],
    };

    this.handleMouseMove = null;
    this.handleMouseDown = null;
    this.handleMouseUp = null;

    this.currentIndex = null;
    this.prevIndex = -1;

    this.cursor = document.querySelector('.cursor-hover');
  }

  init(ctx) {
    this.ctx = ctx;
    this.images = Array.from(document.querySelectorAll('.image-fade'));
    this.slices.numberOf = this.images.length;
    this.slices.width = Math.round(window.innerWidth / this.slices.numberOf);

    let prevNumber = 0;
    this.images.forEach((el, index) => {
      const end = this.slices.width * (index + 1);

      this.slices.sectors.push({ start: prevNumber, end });

      prevNumber = end + 1;
    });

    this.images[0].style.zIndex = this.images.length;
  }

  bindEvents() {
    this.handleMouseMove = event => this.dragging(event);
    this.isHolding = true;

    window.addEventListener('mousemove', this.handleMouseMove);
  }

  unbindEvents() {
    window.removeEventListener('mousemove', this.handleMouseMove);
  }

  dragging(event) {
    if (!store.state.mouseDown) return;

    const mouseX = event.clientX;

    let index = this.slices.sectors.findIndex(el => el.start <= mouseX && mouseX <= el.end);

    if (index === -1 && mouseX < 0) {
      index = 0;
    } else if (index === -1 && mouseX > window.innerWidth) {
      index = this.images.length - 1;
    }

    this.currentIndex = index;

    if (this.currentIndex !== this.prevIndex) {
      this.setImage();
      this.setColorMouse();
    }
  }

  setImage() {
    if (this.images[this.currentIndex] !== undefined) {
      this.images[this.currentIndex].style.opacity = 1;
      this.images[this.currentIndex].style.zIndex = this.images.length;
    }

    if (this.prevIndex > -1 && this.images[this.prevIndex] !== undefined) {
      this.images[this.prevIndex].style.opacity = 1;
      this.images[this.prevIndex].style.zIndex = 0;
    }

    this.prevIndex = this.currentIndex;
  }

  setColorMouse() {
    this.cursor.style.fill = colorsCursor[this.currentIndex];
    this.cursor.style.stroke = colorsCursor[this.currentIndex];
  }

  destroy() {
    this.isHolding = false;
    this.prevIndex = -1;

    this.images.forEach((el, index) => {
      el.style.opacity = 1; // eslint-disable-line
      el.style.zIndex = index === 0 ? this.images.length : 0; // eslint-disable-line
      this.cursor.style.fill = '#ffd300';
      this.cursor.style.stroke = '#ffd300';
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/DragImage.js